import { useNavigate } from "react-router-dom"
import { setNewConversationSearchSource } from "../../../../store/messagingSlice"
import { addPageAction } from "../../../../utils/newrelic"
import type { InboxViewModel, InboxViewModelProps } from "./InboxViewModelTypes"

export const UnifiedViewModel = ({
    dispatch,
}: InboxViewModelProps): InboxViewModel => {
    const navigate = useNavigate()

    const navigateAction = (): void => {
        navigate("/search-users")
        dispatch(setNewConversationSearchSource("icon"))
        addPageAction("DmNewConversationUserSearch", {
            actionType: "init",
            source: "icon",
        })
    }

    const newMessageStarted = (username: string): void => {
        navigate(`/messages/${username}`)
    }

    return {
        newMessageClick: navigateAction,
        newMessageStarted,
    }
}
